import Select from "../../../material/select/SelectV2";
import InputV2 from "../../../material/input/InputV2";
import { medicalTypeList } from "../UserManagementHelper";

const role_list = [
  { key: "MEDICAL_PERSONNEL", value: "แพทย์/เภสัช" },
  { key: "LABORATORY_PERSONNEL", value: "ผู้ปฏิบัติการในห้องปฏิบัติการ" },
  { key: "LABORATORY_ADMIN", value: "ผู้ดูแลห้องปฏิบัติการ" },
];

const License = ({ license, onInputChange, role, type = "licenses" }) => {
  const roleName = role_list.find((r) => r.key === role)?.value || role;

  return (
    <div className="flex flex-col justify-center items-start w-full gap-2 rounded-md border border-[#E2E2E4] p-4 mb-4">
      <h1 className="text-lg font-semibold">ใบประกอบวิชาชีพ ({roleName})</h1>

      <div className="flex flex-col md:flex-row w-full gap-4">
        <div className="flex flex-col text-sm w-full">
          <label className="mb-1">ประเภทวิชาชีพ</label>
          <Select
            value={license.medicalType || ""}
            setValue={(value) => onInputChange("medicalType", value, role, type)}
            list={medicalTypeList}
            placeholder="ประเภทวิชาชีพ"
          />
        </div>

        <div className="flex flex-col text-sm w-full">
          <label className="mb-1">เลขใบประกอบวิชาชีพ</label>
          <InputV2
            type="text"
            placeholder="เลขใบประกอบวิชาชีพ"
            value={license.licenseNumber || ""}
            onChangeEvt={(value) =>
              onInputChange("licenseNumber", value, role, type)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default License;
